import { cloudGatewayBaseUrl } from 'environments/environment';

export const domainServiceEndpoints: Record<string, string> = {

  advertiserChangesUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/advertiser-changes`,

  advertiserOffersUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/offers`,

  advertiserPublishersUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/publishers`,
  advertiserPublisherTagsAndPromotionalTypesUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/tags-and-promotional-types`,

  advertiserTimeZoneUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/advertiser-time-zone`,

  automationsUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/automations`,
  automationUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/automations/:automationId`,
  automationPreviewUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/automations/:automationId/preview`,
  automationTestUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/automations/:automationId/test`,

  communicationsUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/communications`,
  communicationUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/communications/:communicationId`,
  communicationPreviewUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/communications/:communicationId/preview`,
  communicationTestUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/communications/:communicationId/test`,

  messagesUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:publisherId/messages`,
  messageUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:publisherId/messages/:messageId`,
  messageViewUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:publisherId/messages/:messageId/view`,

  publisherAdvertisersUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:publisherId/advertisers`,
  publisherPreferencesUrl: `${cloudGatewayBaseUrl}/communication-centre-preferences/publisher/:publisherId/preference`,
  publisherTimeZoneUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:publisherId/publisher-time-zone`,

  templatesUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/templates`,
  templateUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/templates/:templateId`,
  templatePreviewUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/templates/:templateId/preview`,
  templateTestUrl: `${cloudGatewayBaseUrl}/communication-centre-storage/:advertiserId/templates/:templateId/test`,

};
